// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagFeaturesModel extends SmartTagModel {
	features?: any[];

	constructor() {
		super();
		this.features = [];
	}
}

export class SmartTagFeatures extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagUpdateModel
	 */
	public render(data: SmartTagFeaturesModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagFeaturesModel): void{
		const title = data.title || data.subCategory || '';
		const features = data.features || [];
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}

		if (features && features.length > 0) {
			this.addText(`<span title="Features:">Features:</span>`);
			features.forEach((feature: any) => {
				this.addText(`<span title="${feature.typeName}">&nbsp;&nbsp;&nbsp;&nbsp;${feature.typeName}</span>`);
			});
		}

		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
